<template>
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <label for="asset_id">{{ $t("purchases.chose_acccount") }}</label>
    </div>
    <button type="button" @click="addNewPayAccount" class="btn">
      <span
        class="bx bxs-plus-circle float-end fa-2x"
        style="color: #2a3042 !important"
      ></span>
    </button>
  </div>
  <div v-for="(payAccount, aIndex) in add_pay_accounts" :key="payAccount">
    <div class="purchase-container d-flex mb-sm-2">
      <!--                          @item-select="selectSupplier"-->
      <div class="row w-100">
        <div class="col-12 col-md-5 mb-2 mb-md-1">
          <AutoComplete
            v-model="payAccount.cash_account"
            :suggestions="matched_accounts"
            @item-select="validateCashAccount(payAccount)"
            @complete="accountSearch($event.query)"
            :complete-on-focus="true"
            :optionLabel="showAccountLabel"
            :inputClass="'form-control'"
            class="w-100"
          />
        </div>
        <div class="col-12 col-md-5 mb-2 mb-md-1">
          <currency-input
            :disabled="!payAccount.cash_account"
            v-model="payAccount.value"
            :max="payAccount?.cash_account?.balance"
            class="form-control mb-2 mx-1"
            :placeholder="$t('purchases.amount')"
          ></currency-input>
        </div>
        <div class="col-12 col-md-2 mb-2 mb-md-1">
          <button
            type="button"
            role="button"
            @click="add_pay_accounts.splice(aIndex, 1)"
            :disabled="add_pay_accounts.length == 1"
            class="btn btn-danger"
          >
            <i class="bx bx-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- <h6>
    {{ $t("purchases.total") }}:
     {{ processCurrency(selectedCurrency, totalAddPayAccounts, true) }} 
  </h6> -->
</template>

<script>
export default {
  data() {
    return {
      matched_accounts: [],
      add_pay_accounts: [{}],
    };
  },
  props: {
    cashAccounts: Array,
    modelValue: Object,
    selectedCurrency: Object,
  },
  emits: ["update:modelValue"],

  computed: {
    totalAddPayAccounts() {
      return this.add_pay_accounts
        .filter((account) => account.value)
        .reduce((sum, account) => {
          console.log("step 77", this.selectedCurrency);
          console.log("step 78", account);
          if (
            this.selectedCurrency?.id != account.cash_account.currency_id &&
            this.selectedCurrency?.is_functional
          ) {
            sum +=
              parseFloat(account.value) *
              parseFloat(account.cash_account.current_rate);
          } else if (
            this.selectedCurrency?.id != account.cash_account.currency_id &&
            account.cash_account.is_functional
          ) {
            sum +=
              parseFloat(account.value) /
              parseFloat(this.selectedCurrency?.current_rate);
          } else if (
            this.selectedCurrency?.id != account.cash_account.currency_id
          ) {
            sum +=
              (parseFloat(account.value) *
                parseFloat(this.selectedCurrency?.current_rate)) /
              parseFloat(account.cash_account.current_rate);
          } else {
            sum += parseFloat(account.value);
          }
          return sum;
        }, 0);
    },
  },

  methods: {
    addNewPayAccount() {
      this.add_pay_accounts.push({});
    },
    validateCashAccount(payAccount) {
      this.$emit("update:modelValue", this.add_pay_accounts);
      payAccount.value = 0;
      if (parseFloat(payAccount.cash_account.balance) == 0) {
        payAccount.cash_account = "";
      }
    },
    accountSearch(query) {
      console.log('zaza', this.add_pay_accounts, this.cashAccounts)
      this.matched_accounts = this.cashAccounts.filter(
        (account) =>
          (account.name.includes(query) ||
            account.name_en.toLowerCase().includes(query.toLowerCase())) &&
          !this.add_pay_accounts.some(
            (payAccount) =>
              payAccount?.cash_account?.cash_account_id ==
              account.cash_account_id
          )
      );
      console.log("this.matched_accounts", this.matched_accounts);
    },
    showAccountLabel(account) {
      console.log("ACCOUNT", account);
      return (
        (this.$i18n.locale == "ar" ? account?.name : account?.name_en) +
        " - "
      );
    },
  },
  mounted() {
    console.log("step 135 :", this.cashAccounts);
  },
};
</script>

<style></style>
